/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, ViewEncapsulation, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { BsModalRef} from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { CommonService } from '../services/common.service';
import { Subject } from 'rxjs';

export class VolumeRequirementsModalContext {
  public data: any;
  dialogClass?: string;
}

@Component({
  templateUrl: './volume-requirements-modal.component.html',
  styleUrls: ['./volume-requirements-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class VolumeRequirementsModalComponent implements OnInit {
  @ViewChild('volumeRequirementsForm') volumeRequirementsForm!: NgForm;
  @Output() closeModal = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  @Input() context!: VolumeRequirementsModalContext;
  public isFromChangeSponsor!: boolean;
  private param: any;
  public title!: string;
  public volumeRules: any = [];
  public noVolumeRules = false;
  public operationIndex = 0;
  public onCloseModal: Subject<any>;

  constructor(public bsModalRef: BsModalRef,
    private commonService: CommonService) {
      this.onCloseModal = new Subject();
  }

  ngOnInit() {
    if (this.context?.data) {
      this.title = this.context.data.title;
      this.volumeRules = this.context.data.volumeRules || [];
    }

    this.volumeRules.forEach((volRule: any) => {
      volRule['operation'] = 'Update';
      volRule['volumeType'] = volRule.type;
      volRule['operationIndex'] = this.operationIndex;
      this.operationIndex++;
    });
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow() {
    this.onClose.next('closed');
    this.bsModalRef.hide();
  }

  public applyChange() {
    this.volumeRules.forEach((volRule: any) => {
      volRule['volumeType'] = this.getType(volRule.code);
    });
    this.onClose.next({ data: this.volumeRules });
    this.bsModalRef.hide();
    this.bsModalRef?.content?.onClose?.next({ data: this.volumeRules });
  }

  private getType(code: any) {
    let returnCode = '';
    this.context.data.allVolumeDefinitionMetadata.forEach((item: any) => {

      if (item.code === code) {
        returnCode = item.type;
      }
    });
    return returnCode;
  }

  public addNewVolume() {
    this.noVolumeRules = false;
    const volRule: any = {};
    volRule['operation'] = 'Create';
    volRule['code'] = '';
    volRule['value'] = '';
    volRule['operationIndex'] = this.operationIndex;
    this.operationIndex++;
    this.volumeRules.push(volRule);
  }

  public removeVolume(volRule: any, index: number) {

    if (volRule.id) {
      volRule['operation'] = 'Delete';
      this.volumeRequirementsForm.form.markAsDirty();
    }else {
      this.volumeRules.splice(index, 1);
    }

    // logic to show No Volume Rules
    const deletedRules = this.volumeRules.filter(function(rule: any) {
      return (rule.operation === 'Delete');
    });
    this.noVolumeRules = (deletedRules.length === this.volumeRules.length);
  }

  onKeyPress(evt: any) {
    // This function will allow user to enter only numeric values (0-9)in the input field & restricting .
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode !== 46 && charCode >= 48 && charCode <= 57) {
      return true;
    }
    return false;
  }

  public onKeyDown(evt: any){
    // here we are restricting the user to enter 1/2 (fraction),m, k 
    const restrcitKeys=[189, 109, 107];
    if (restrcitKeys.indexOf(evt.keyCode)>-1) {
      return false;
    } else {
      return true;
    }
  }

}